import React, { useEffect, useState } from 'react';
import {
  Routes,
  Route,
  useNavigate,
} from 'react-router-dom';
import { useConfig } from './config/ConfigContext';

// Jifiti
import LuwaLanding from './containers/landing/LuwaLanding';
import LuwaCheckinVerification from './containers/verification/LuwaCheckin';
import LuwaMicrobilt from './containers/microbilt/LuwaVerification';
import LuwaPlaid from './containers/plaid/LuwaVerification';
import LuwaPlaidWelcome from './containers/plaid/LuwaWelcome';
import LuwaMicrobiltWelcome from './containers/microbilt/LuwaWelcome';
import LuwaDenied from './containers/results/LuwaDenied';
import LuwaACH from './containers/payment/LuwaACH';
import DPOnlyDebitCardElection from './containers/dp-only/payment/DebitCardElection';
import DPOnlyThankYou from './containers/dp-only/payment/ThankYou';
import LuwaConfirmed from './containers/payment/LuwaConfirmed';
import LuwaSecurity from './containers/security/LuwaSecurity';
import LuwaWelcome from './containers/luwa/welcome';
import LuwaAgreementDeclined from './containers/agreement/LuwaDeclined';
import LuwaComplete from './containers/complete/LuwaComplete';
import LuwaPending from './containers/results/LuwaPending';
import LuwaConfirmation from './containers/identity/LuwaConfirmation';
import LuwaQuestions from './containers/identity/LuwaQuestions';
import LuwaManualVerification from './containers/identity/LuwaManualVerification';
import LuwaVerify from './containers/payment/LuwaVerify';
import LuwaIncomeWaiting from './containers/microbilt/LuwaWaiting';
import LuwaContinue from './containers/results/LuwaContinue';
import LuwaRedirection from './containers/redirection';
import LuwaCheck from './containers/payment/LuwaCheck';
import LuwaManual from './containers/payment/LuwaManual';
import LuwaLoanDetails from './containers/loan-details/LuwaLoanDetails';
import LuwaCreditFreeze from './containers/results/LuwaCreditFreeze';
import RedirectExternalSite from './containers/RedirectExternalSite';
import LuwaSignLoanDocument from './containers/SignLoanDocument';
import OfferConfirmation from './containers/OfferConfirmation';
import OfferConfirmed from './containers/results/offerConfirmed';
import OTP from './containers/otp';
import ResendCode from './containers/otp/ResendCode';
import LoanOptions from './containers/dp-only/loan-options/LoanOptions';
import EsignLoanDocs from './containers/esign-loan-documents';
import AgreementSign from './containers/agreement/LuwaSign';
import PickPaymentDate from './containers/PickPaymentDate';
import Reprompting from './containers/Reprompting';

import './assets/scss/App.scss';

const routes = [
  { exact: true, path: '/', element: LuwaLanding },
  { exact: true, path: '/:workflowType', element: LuwaLanding },
  { path: '/:workflowType/checkin', element: LuwaCheckinVerification },
  { path: '/:workflowType/security/main', element: LuwaSecurity },
  { path: '/:workflowType/welcome', element: LuwaWelcome },
  { path: '/:workflowType/microbilt/verification', element: LuwaMicrobilt },
  { path: '/plaid/verification', element: LuwaPlaid },
  { path: '/:workflowType/plaid/verification', element: LuwaPlaid },
  { path: '/plaid/welcome', element: LuwaPlaidWelcome },
  { path: '/:workflowType/microbilt/welcome', element: LuwaMicrobiltWelcome },
  { path: '/:workflowType/payment/ach', element: LuwaACH },
  { path: '/:workflowType/payment/debitcardelection', element: DPOnlyDebitCardElection },
  { path: '/:workflowType/down-payment-hold-thank-you', element: DPOnlyThankYou },
  { path: '/:workflowType/payment/confirmed', element: LuwaConfirmed },
  { path: '/:workflowType/results/denied', element: LuwaDenied },
  { path: '/:workflowType/agreement/declined', element: LuwaAgreementDeclined },
  { path: '/:workflowType/application/identity/confirmation', element: LuwaConfirmation },
  { path: '/:workflowType/application/identity/questions', element: LuwaQuestions },
  { path: '/:workflowType/application/identity/manual-verification', element: LuwaManualVerification },
  { path: '/:workflowType/external-site', element: RedirectExternalSite },
  { path: '/:workflowType/application/signloandocument', element: LuwaSignLoanDocument },
  { path: '/:workflowType/complete', element: LuwaComplete },
  { path: '/:workflowType/redirect', element: LuwaRedirection },
  { path: '/:workflowType/select-offer', element: LoanOptions },
  { path: '/:workflowType/results/pending', element: LuwaPending },
  { path: '/:workflowType/contract/sign', element: EsignLoanDocs },
  { path: '/:workflowType/agreement/sign', element: AgreementSign },
  { path: '/:workflowType/payment/verify', element: LuwaVerify },
  { path: '/:workflowType/pick-payment-date', element: PickPaymentDate },
  { path: '/:workflowType/income/waiting', element: LuwaIncomeWaiting },
  { path: '/:workflowType/results/continue', element: LuwaContinue },
  { path: '/:workflowType/payment/check', element: LuwaCheck },
  { path: '/:workflowType/payment/manual', element: LuwaManual },
  { path: '/:workflowType/loan-details', element: LuwaLoanDetails },
  { path: '/:workflowType/results/creditfreeze', element: LuwaCreditFreeze },
  { path: '/offer/terms', element: OfferConfirmation },
  { path: '/:workflowType/offer/terms', element: OfferConfirmation },
  { path: '/offer/confirmed', element: OfferConfirmed },
  { path: '/:workflowType/offer/confirmed', element: OfferConfirmed },
  { path: '/:workflowType/otp', element: OTP },
  { path: '/:workflowType/resend-otp', element: ResendCode },
  { path: '/:workflowType/reprompting', element: Reprompting },
];

const App = () => {
  const appConfig = useConfig();
  const navigate = useNavigate();
  const [isEsignPage, setIsEsignPage] = useState(false);

  const addPageSenseScript = () => {
    const scriptTag = document.createElement('script');
    scriptTag.src = `https://cdn.pagesense.io/js/lendingusa/${appConfig.pageSenseId}.js`;
    document.head.appendChild(scriptTag);
  };

  useEffect(() => {
    if (appConfig.pageSenseId) {
      addPageSenseScript();
    }

    const currentPath = window.location.pathname;
    setIsEsignPage(currentPath.includes('/esign'));
  }, []);

  useEffect(() => {
    const appElement = document.getElementById('App');
    if (isEsignPage) {
      appElement.classList.add('full-width');
    } else {
      appElement.classList.remove('full-width');
    }
  }, [isEsignPage]);

  return (
    <Routes>
      {routes.map((route) => (
        <Route
          exact={route.exact}
          path={route.path}
          key={route.path}
          element={<route.element navigate={navigate} />}
        />
      ))}
    </Routes>
  );
};

export default App;
